<template>
    <div id="SwellCX" v-show="this.data_api !== null">
        <div
            class="swell-chat-fixed swell-chat-bottom-0 swell-chat-flex swell-chat-flex-col swell-chat-font-size-px"
            style="z-index: 9187281237;" v-if="launcher"
            :style="[
                settings.corner === 'left' ? { 'left' : sideDistancePx } : { 'right' : sideDistancePx },
                { bottom: bottomDistancePx }
            ]"
            :class="[
                opened ? 'sm:swell-chat-mobile' : '',
                display < 465 ? 'mr-3' : '',
                settings.corner === 'left' ? '' : 'swell-chat-items-end swell-chat-right-0'
            ]">

            <!--  Welcome  -->
            <div class="swell-chat-flex swell-chat-flex-col"
                 :class="[ settings.corner === 'left' ? '' : 'swell-chat-ml-24' ]"
                 :style="[
                     settings.welcome_alignment === 'side' && settings.corner === 'left' ? { 'margin-left' : '80px', 'margin-bottom' : '-80px' } : '',
                     settings.welcome_alignment === 'side' && settings.corner === 'right' ? { 'margin-right' : '80px', 'margin-bottom' : '-80px' } : '',
                 ]" v-if="welcome">
                <div @click="closeWelcome"
                     class="swell-chat-cursor-pointer swell-chat-tracking-wider swell-chat-py-px swell-chat-bg-gray-400 swell-chat-rounded-full swell-chat-px-2 swell-chat-text-gray-600 swell-chat-text-sm swell-chat-self-end swell-chat-mb-1">
                    close
                </div>

                <div @click="launcherClick"
                     class="swell-chat-cursor-pointer swell-chat-bg-white swell-chat-rounded-lg swell-chat-w-full swell-chat-max-w-sm swell-chat-mb-3 swell-chat-p-4 swell-chat-flex swell-chat-space-x-3 swell-chat-shadow-lg swell-chat-relative">

                    <img alt="welcome-chat-avatar" v-if="settings.avatar"
                         :src="settings.avatar === settings.custom_avatar ? settings.avatar_url : `${base_url}/widget/images/avatar/${settings.avatar}`"
                         class="swell-chat-rounded-full" style="width: 50px !important; height: 50px !important;">

                    <span class="swell-chat-text-gray-600 swell-chat-text-sm swell-chat-font-medium-600"
                          style="z-index: 1">
                        {{ settings.welcome_text }}
                    </span>

                    <div style="z-index: 0"
                         :style="[
                            settings.welcome_alignment === 'side' && settings.corner === 'left' ? { 'left': '-17px', 'bottom': '40px' } : '',
                            settings.welcome_alignment === 'side' && settings.corner === 'right' ? { 'right': '-7px', 'bottom': '40px'  } : ''
                         ]"
                         :class="[
                             settings.corner === 'left' ? '' : 'swell-chat-right-5',
                             settings.welcome_alignment === 'side' ? '' : 'swell-chat-bottom-0'
                          ]"
                         class="swell-chat-bg-white mt-1 swell-chat-w-4 swell-chat-h-4 swell-chat-absolute swell-chat-transform swell-chat-rotate-45 swell-chat-rounded swell-chat--mb-1">
                    </div>
                </div>
            </div>

            <!-- Conversation Box -->
            <transition name="swell-chat-slide-fade">
                <div v-if="opened"
                     class="swell-chat-overflow-hidden swell-chat-rounded-lg swell-chat-w-full swell-chat-max-w-sm swell-chat-mb-3 swell-chat-shadow-lg sm:swell-chat-mobile swell-chat-max-h-lg">

                    <!-- Header -->
                    <div>
                        <!-- Group -->
                        <div class="swell-chat-text-white swell-chat-p-3 swell-chat-flex swell-chat-flex-col"
                             v-if="settings.use_groups"
                             :style="{ backgroundColor: settings.bg_header_group_color }">
                            <!-- Selected -->
                            <div v-if="hasSelectedGroup">
                                <div class="swell-chat-flex swell-chat-space-x-2">
                                    <div class="swell-chat-text-2xl">{{ selectedGroup.name }}</div>
                                </div>
                                <div class="swell-chat-text-sm">{{ selectedGroup.description }}</div>
                            </div>

                            <!-- Groups List -->
                            <div v-else>
                                <div class="swell-chat-flex swell-chat-space-x-2 swell-chat-items-center">
                                    <img v-if="settings.avatar"
                                         :src="settings.avatar === settings.custom_avatar ? settings.avatar_url : `${base_url}/widget/images/avatar/${settings.avatar}`"
                                         class="swell-chat-rounded-full"
                                         alt="group-avatar"
                                         style="width: 50px;">
                                    <div class="swell-chat-text-2xl">{{ settings.group_title_header }}</div>
                                </div>
                                <div class="swell-chat-text-sm">{{ settings.group_text_header }}</div>
                            </div>
                        </div>

                        <!-- Default Header -->
                        <div v-else>
                            <div
                                class="swell-chat-text-white swell-chat-p-3 swell-chat-flex swell-chat-items-center sm:swell-chat-mobile-header-height"
                                :style="{ backgroundColor: settings.bg_header_color }">
                                <img alt="swell-header-avatar"
                                     v-if="settings.avatar"
                                     :src="settings.avatar === settings.custom_avatar ? settings.avatar_url : `${base_url}/widget/images/avatar/${settings.avatar}`"
                                     class="swell-chat-rounded-full"
                                     style="width: 50px;">
                                <div class="swell-chat-flex swell-chat-flex-col swell-chat-pl-3">
                                    <span class="swell-chat-text-2xl">{{ settings.title_header }}</span>
                                    <p class="swell-chat-text-sm">{{ settings.text_header }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Body -->
                    <div
                        class="swell-chat-bg-white swell-chat-px-2 swell-chat-py-4 swell-chat-min-w-sm sm:swell-chat-mobile-min-height swell-chat-input-group-height swell-chat-overflow-scroll-always"
                        style="position: relative;">

                        <div v-if="activeStep==='type-selector'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-mb-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                {{ settings.text_invitation }}
                            </div>

                            <div class="swell-chat-py-4">
                                <!-- Button Request Appointment -->
                                <div @click="selectChatType('apptRequest')"
                                     class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-mr-12 swell-chat-ml-12 swell-chat-shadow-lg swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                    <div class="swell-chat-font-medium">Request Appointment</div>
                                </div>

                                <!-- Webchat Only -->
                                <div @click="selectChatType('webchatOnly')"
                                     class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-mr-12 swell-chat-ml-12 swell-chat-shadow-lg swell-chat-mt-5 swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                    <div class="swell-chat-font-medium">Chat with us</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='complete-form'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                {{ settings.text_invitation }}
                            </div>

                            <!-- Form Fields -->
                            <div
                                class="swell-chat-bg-gray-100 swell-chat-py-4 swell-chat-px-5 swell-chat-ml-8 swell-chat-mt-5"
                                style="border-radius: 0.7em 0.7em 0px 0.7em;">
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md">
                                    <input id="swell-chat-name" required="required" v-model="form.name"
                                           class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                           :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('name') }"
                                           placeholder="Your name"/>
                                    <div
                                        class="swell-chat-absolute swell-chat-inset-y-0 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('name')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex">
                                    <select id="swell-chat-country-code" type="tel" required="required"
                                           v-model="form.country_code"
                                           class="swell-chat-form-input swell-chat-block swell-chat-w-1/3 swell-chat-sm:text-sm swell-chat-sm:leading-5 swell-chat-mr-2"
                                           :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('country_code') }"
                                           >
                                        <option v-for="countryCode in countryCodes"
                                                :key="countryCode.id" :value="countryCode.id">
                                            {{countryCode.short_name}} {{countryCode.code}}
                                        </option>
                                    </select>
                                    <input id="swell-chat-phone-number" type="tel" required="required"
                                           v-model="form.phone_number"
                                           class="swell-chat-form-input swell-chat-block swell-chat-w-2/3 swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                           :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('phone_number') }"
                                           placeholder="Phone Number"/>
                                    <div
                                        class="swell-chat-absolute swell-chat-inset-y-0 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('phone_number')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="swell-chat-text-xs swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex swell-chat-sm:text-sm swell-chat-border-red-300 swell-chat-text-red-900" v-if="form.errors.has('phone_number')">
                                    {{form.errors.get('phone_number')}}
                                </div>
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5">
                                    <textarea id="swell-chat-message" required v-model="form.message" v-on:keyup="messageCount"
                                              class="swell-chat-form-textarea swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                              :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('message') }"
                                              placeholder="Write your message here..." :rows=textareaMessage.rows
                                              style="min-width: 100% !important; width: 100% !important;"></textarea>
                                    <div
                                        class="swell-chat-absolute swell-chat-top-3 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('message')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                    <div class="swell-chat-text-right swell-chat-text-gray-400 swell-chat-text-xs"
                                        :class="{ 'swell-chat-text-red-900' : message_count >= 1600 }">
                                        {{message_count}} / 1600
                                    </div>
                                    <div class="swell-chat-text-xs swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex swell-chat-sm:text-sm swell-chat-border-red-300 swell-chat-text-red-900" v-if="form.errors.has('message')">
                                        {{form.errors.get('message')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='personal-form'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                Please enter your name and phone number to continue
                            </div>

                            <!-- Form Fields -->
                            <div
                                class="swell-chat-bg-gray-100 swell-chat-py-4 swell-chat-px-5 swell-chat-ml-8 swell-chat-mt-5"
                                style="border-radius: 0.7em 0.7em 0px 0.7em;">
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md">
                                    <input id="swell-chat-name_appointment" required="required" v-model="form.name"
                                           class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                           :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('name') }"
                                           placeholder="Your name"/>
                                    <div
                                        class="swell-chat-absolute swell-chat-inset-y-0 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('name')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex">
                                    <select id="swell-chat-country-code_appointment" type="tel" required="required"
                                            v-model="form.country_code"
                                            class="swell-chat-form-input swell-chat-block swell-chat-w-1/3 swell-chat-sm:text-sm swell-chat-sm:leading-5 swell-chat-mr-2"
                                            :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('country_code') }"
                                    >
                                        <option v-for="countryCode in countryCodes"
                                                :key="countryCode.id" :value="countryCode.id">
                                            {{countryCode.short_name}} {{countryCode.code}}
                                        </option>
                                    </select>
                                    <input id="swell-chat-phone-number_appointment" type="tel" required="required"
                                           v-model="form.phone_number"
                                           class="swell-chat-form-input swell-chat-block swell-chat-w-2/3 swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                           :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('phone_number') }"
                                           placeholder="Phone Number"/>
                                    <div
                                        class="swell-chat-absolute swell-chat-inset-y-0 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('phone_number')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex swell-chat-sm:text-sm swell-chat-border-red-300 swell-chat-text-red-900" v-if="form.errors.has('phone_number')">
                                    {{form.errors.get('phone_number')}}
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='group-selector'">
                            <div class="swell-chat-mt-1 swell-chat-mb-3 swell-chat-relative swell-chat-rounded-md">
                                <input id="swell-chat-search" @input="groupSearchFilter($event.target.value)"
                                       class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-pl-10 swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                       placeholder="Search"/>
                                <div
                                    class="swell-chat-left-0 swell-chat-pl-3 swell-chat-absolute swell-chat-inset-y-0 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none">
                                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                         class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-gray-400">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                                    </svg>
                                </div>
                            </div>

                            <div v-if="failedGroupFilter"
                                 class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-px-5 swell-chat-py-2">
                                <div class="swell-chat-tracking-wide">* No match found!</div>
                            </div>

                            <div v-for="group in filteredSelectedGroups" :key="group.id">
                                <div @click="groupSelected(group)"
                                     :style="toggleSelectedButton(selectedGroup===group)"
                                     class="swell-chat-text-sm swell-chat-rounded-lg swell-chat-px-5 swell-chat-py-2 swell-chat-mt-1 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                    <div class="swell-chat-font-medium-600 swell-chat-font-size-px">{{ group.name }}
                                    </div>
                                    <div class="swell-chat-opacity-90 swell-chat-tracking-wide">{{ group.description
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='recurrent-patient-selector'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-mb-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                Are you a {{ settings.user_first_type }} or {{ settings.user_second_type }}?
                            </div>

                            <div class="swell-chat-py-4">
                                <!-- Button New Patient -->
                                <div @click="setExistingPatient(false)"
                                     :style="toggleSelectedButton(this.form.user_type_selected === false)"
                                     class="swell-chat-text-sm swell-chat-rounded-lg swell-chat-mr-12 swell-chat-ml-12 swell-chat-shadow-lg swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                    <div class="swell-chat-font-medium">{{ settings.user_first_type }}</div>
                                </div>

                                <!-- Button Existing Patient -->
                                <div @click="setExistingPatient(true)"
                                     :style="toggleSelectedButton(this.form.user_type_selected === true)"
                                     class="swell-chat-text-sm swell-chat-rounded-lg swell-chat-mr-12 swell-chat-ml-12 swell-chat-shadow-lg swell-chat-mt-5 swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                    <div class="swell-chat-font-medium">{{ settings.user_second_type }}</div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='preferred-day-selector'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-mb-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                Please select which days are most convenient for you
                            </div>

                            <div
                                class="swell-chat-flex swell-chat-flex-wrap swell-chat-justify-between swell-chat-mr-8 swell-chat-ml-8">
                                <div v-for="day in settings.preferred_days" :key="day"
                                     class="swell-chat-w-36 swell-chat-mb-3">
                                    <div @click="setPreferredDay(day)"
                                         :style="toggleSelectedButton(form.preferred_days.includes(day))"
                                         class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-shadow-lg swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent swell-chat-text-center hover:swell-chat-border-gray-500">
                                        <div class="swell-chat-font-medium">{{ day }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='preferred-time-selector'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-mb-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                Please select the time(s) that are most convenient for you
                            </div>

                            <div
                                class="swell-chat-flex swell-chat-flex-wrap swell-chat-justify-between swell-chat-mr-8 swell-chat-ml-8">
                                <div v-for="time in settings.preferred_times" :key="time"
                                     class="swell-chat-w-36 swell-chat-mb-3">
                                    <div @click="setPreferredTime(time)"
                                         :style="toggleSelectedButton(form.preferred_times.includes(time))"
                                         class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-shadow-lg swell-chat-px-5 swell-chat-py-4 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent swell-chat-text-center hover:swell-chat-border-gray-500">
                                        <div class="swell-chat-font-medium">{{ time }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='additional-notes-form'">
                            <!-- Text Invitation -->
                            <div
                                class="swell-chat-bg-gray-300 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700 swell-chat-mr-8 swell-chat-rounded-lg"
                                style="border-radius: 0.7em 0.7em 0.7em 0px;">
                                Please provide any additional notes regarding your request
                            </div>

                            <!-- Form Fields -->
                            <div
                                class="swell-chat-bg-gray-100 swell-chat-py-4 swell-chat-px-5 swell-chat-ml-8 swell-chat-mt-5"
                                style="border-radius: 0.7em 0.7em 0px 0.7em;">
                                <div class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5">
                                    <textarea id="swell-chat-additional_notes" required v-model="form.additional_notes" v-on:keyup="additionaNotesCount"
                                              class="swell-chat-form-textarea swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                              :class="{ 'swell-chat-border-red-300 swell-chat-text-red-900 swell-chat-placeholder-red-300 focus:swell-chat-border-red-300 focus:swell-chat-shadow-outline-red' : form.errors.has('additional_notes') }"
                                              placeholder="Type" :rows=textareaAdditionalNotes.rows
                                              style="min-width: 100% !important; width: 100% !important;"></textarea>
                                    <div
                                        class="swell-chat-absolute swell-chat-top-3 swell-chat-right-0 swell-chat-pr-3 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none"
                                        v-if="form.errors.has('additional_notes')">
                                        <svg class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-red-500"
                                             fill="currentColor" viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"/>
                                        </svg>
                                    </div>
                                    <div class="swell-chat-text-right swell-chat-text-gray-400 swell-chat-text-xs"
                                         :class="{ 'swell-chat-text-red-900' : additional_notes_count >= 1600 }">
                                        {{additional_notes_count}} / 1600
                                    </div>
                                    <div class="swell-chat-text-xs swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-mt-5 swell-chat-flex swell-chat-sm:text-sm swell-chat-border-red-300 swell-chat-text-red-900" v-if="form.errors.has('additional_notes')">
                                        {{form.errors.get('additional_notes')}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="activeStep==='success'">
                            <div
                                class="swell-chat-bg-gray-50 swell-chat-rounded-lg swell-chat-p-5 swell-chat-text-gray-700 swell-chat-space-y-2 swell-chat-mt-5">
                                <div class="swell-chat-flex swell-chat-space-x-2 swell-chat-font-medium">
                                    <img alt="check-icon" :src="`${base_url}/widget/images/check.svg`"
                                         class="swell-chat-w-5">

                                    <span>We got your message!</span>
                                </div>
                                <div class="swell-chat-text-sm swell-chat-tracking-wide">
                                    Our team will be texting you back from the number <span
                                    class="swell-chat-font-medium swell-chat-tracking-wider">{{ phone_number }}</span>.
                                </div>
                            </div>
                        </div>

                        <!-- Step Legend / Buttons -->
                        <div
                            class="swell-chat-right-0 swell-chat-bottom-0 swell-chat-w-full swell-chat-font-size-px swell-chat-items-center">
                            <div v-if="(activeStep==='complete-form' || activeStep==='additional-notes-form')"
                                     class="swell-chat-w-full swell-chat-text-gray-400 swell-chat-text-xs swell-chat-text-center swell-chat-mt-1">
                                     <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 15px;">
                                        <input type="checkbox" v-model="tcrAccepted" :checked="tcrAccepted" style="align-self: start; min-width: 13px"/>
                                        <p class="swell-chat-consent-text">By providing your phone number and pressing Submit, you agree to receive recurring text communications at the number provided. Message frequency may vary. Reply STOP to unsubscribe or HELP for help. MSG & Data Rates may apply.</p>
                                     </div>
                            </div>
                            <!-- Buttons -->
                            <div class="swell-chat-mr-12 swell-chat-ml-12 swell-chat-py-4">
                                <div v-if="showFooterButtons"
                                     class="swell-chat-flex swell-chat-w-full swell-chat-items-center swell-chat-justify-center"
                                     :class="{'swell-chat-justify-between': !showOnlySubmitButton}">
                                    <div v-if="flow.activeStep > 0"
                                         @click="previousStep()"
                                         class="hover:swell-chat-border-gray-500 swell-chat-border-2 swell-chat-border-transparent swell-chat-cursor-pointer swell-chat-flex swell-chat-pr-3 swell-chat-py-2 swell-chat-rounded-lg swell-chat-text-gray-500 swell-chat-text-md">
                                        <svg class="swell-chat-w-9" xmlns="http://www.w3.org/2000/svg" width="24"
                                             height="24" viewBox="0 0 24 24">
                                            <path class="fill-current"
                                                  d="M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z"></path>
                                        </svg>
                                        Go Back
                                    </div>
                                    <div v-else></div>

                                    <div v-if="isLastStep"
                                         class="swell-chat-flex swell-chat-flex-col swell-chat-items-center swell-chat-space-y-2">
                                        <button :disabled="submitting || !tcrAccepted" :style="{ backgroundColor: (submitting || !tcrAccepted) ? 'grey' : bgHeaderColor }"
                                                @click="send()"
                                                class="swell-chat-text-l swell-chat-items-center swell-chat-text-white swell-chat-flex swell-chat-rounded-lg swell-chat-px-5 swell-chat-py-2 swell-chat-opacity-80 hover:swell-chat-opacity-100">
                                            <span v-if="submitting" class="swell-chat-mr-2">Sending</span>
                                            <span v-else class="swell-chat-mr-2">Submit</span>
                                        </button>
                                    </div>

                                    <div v-else @click="nextStep()"
                                         class="hover:swell-chat-border-gray-500 swell-chat-bg-gray-100 swell-chat-border-2 swell-chat-border-transparent swell-chat-cursor-pointer swell-chat-px-5 swell-chat-py-2 swell-chat-rounded-lg swell-chat-shadow-lg swell-chat-text-gray-500 swell-chat-text-md">
                                        <div class="swell-chat-font-medium">Skip / Next</div>
                                    </div>
                                </div>


                            </div>

                            <div v-if="showFooterButtons && !showOnlySubmitButton"
                                 class="swell-chat-flex swell-chat-w-full swell-chat-items-center swell-chat-justify-center swell-chat-p-3">
                                <span class="swell-chat-text-sm">Step {{ (flow.activeStep + 1) }} of {{ (countSteps - 1) }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div
                        class="sm:swell-chat-mobile-footer-height swell-chat-cursor-pointer swell-chat-bg-gray-200 swell-chat-flex swell-chat-justify-center swell-chat-text-xs swell-chat-py-2 swell-chat-items-center swell-chat-space-x-1"
                        @click="accessSwellSite" v-if="!settings.use_cobrand">
                        <img alt="swell-logo" :src="`${base_url}/widget/images/power-icon.svg`"
                             style="height: 20px !important; width: 20px !important"/>
                        <span>We run on Swell</span>
                    </div>
                    <div
                        class="sm:swell-chat-mobile-footer-height swell-chat-cursor-pointer swell-chat-bg-gray-200 swell-chat-flex swell-chat-justify-center swell-chat-text-xs swell-chat-py-2 swell-chat-items-center swell-chat-space-x-1"
                        @click="accessSwellSite" v-else>
                        <img alt="swell-logo" :src="this.settings.cobrand_logo"
                             style="height: 20px !important; width: 20px !important"/>
                        <span>{{this.settings.cobrand_name}}</span>
                        <span style="font-size: xx-small; color: #808080"> - Powered by Swell </span>
                    </div>
                </div>
            </transition>

            <!--  Launcher Button  -->
            <div @click="launcherClick"
                 class="swell-chat-w-16 swell-chat-h-16 swell-chat-rounded-full swell-chat-flex swell-chat-items-center swell-chat-justify-center swell-chat-cursor-pointer swell-chat-icon-shadow-lg"
                 :style="{ backgroundColor: opened ? '#e73e51' : settings.bg_launcher_color }"
                 :class="{'sm:swell-chat-mobile-minimize': opened}">
                <transition name="swell-chat-rotate">
                    <div v-if="!opened && !transitioning">
                        <img alt="swell-avatar"
                             :src="settings.custom_icon ? `${settings.icon_url}` : `${base_url}/widget/images/launcher-icon-default.png`"
                             width="40px"/>
                    </div>
                </transition>
                <div v-if="opened && !transitioning">
                    <img alt="close-icon" :src="`${base_url}/widget/images/launcher-icon-close.svg`"
                         class="swell-chat-w-4"
                         :class="[opened ? 'sm:swell-chat-mobile-exit' : '']"/>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Form from '../utils/Form';

    export default {
        name: 'chat',
        data() {
            return {
                message_count         : 0,
                additional_notes_count: 0,
                base_url              : '',
                data_api              : null,
                form                  : null,
                settings              : {},
                welcome               : false,
                opened                : false,
                submited              : false,
                submitting            : false,
                tcrAccepted           : false,
                textareaMessage       : {
                    height: 23,
                    rows: 1
                },
                textareaAdditionalNotes : {
                    height: 23,
                    rows: 1
                },
                launcher              : false,
                display               : '',
                localStorageKey       : 'swellCX-website-widget-welcome-dismissed',
                localStorageKeyClick  : 'swellCX-website-widget-user-id',
                sendMessage           : true,
                filteredSelectedGroups: [],
                failedGroupFilter     : false,
                selectedGroup         : null,
                resizeIndexMessage    : [],
                resizeIndexAdditionalNotes : [],
                transitioning         : false,
                phone_number          : '',
                customizations        : {},
                flow                  : {
                    activeStep : 0,
                    sequences  : {
                        steps: [],
                        webchatOnly: [
                            'type-selector',
                            'group-selector',
                            'complete-form',
                            'success',
                        ],
                        apptRequest: [
                            'type-selector',
                            'personal-form',
                            'group-selector',
                            'recurrent-patient-selector',
                            'preferred-day-selector',
                            'preferred-time-selector',
                            'additional-notes-form',
                            'success',
                        ],
                    },
                    formSteps: [
                        'complete-form',
                        'personal-form',
                    ],
                    countryCodes: [],
                },
            };
        },

        watch: {
            'form.message': function () {
                this.manageTextArea('swell-chat-message');
            },

            'form.additional_notes': function () {
                this.manageTextArea('swell-chat-additional_notes');
            },

            'form.phone_number': function () {
                // this.form.phone_number = this.form.phone_number.replace(/[^0-9]/g, '')
                //     .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
            }
        },

        beforeMount() {
            this.getCustomizations();
            this.fetchCountryCodes();
        },

        created() {
            let elem    = document.querySelector('script[data-api-token]');
            let src     = elem.getAttribute('src');
            let dataApi = elem.getAttribute('data-api-token');

            if (src.indexOf('#') && src.split('#')[1] === dataApi) {
                let url = new URL(src.split('#')[0]);

                this.base_url = url.origin;
                this.data_api = dataApi;
            }

            window.addEventListener('resize', this.onResize);
            this.onResize();
            this.setupForm();
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },

        computed: {
            countSteps() {
                return this.flow.sequences.steps.length;
            },

            activeStep() {
                return this.flow.sequences.steps[this.flow.activeStep];
            },

            isLastStep() {
                return ((this.flow.activeStep + 1) === (this.countSteps - 1));
            },

            bgHeaderColor() {
                return this.settings.use_groups ? this.settings.bg_header_group_color : this.settings.bg_header_color;
            },

            hasSelectedGroup() {
                return this.selectedGroup != null;
            },

            showFooterButtons() {
                return this.activeStep !== 'type-selector' && this.activeStep !== 'success' && this.activeStep !== 'group-selector';
            },

            showOnlySubmitButton() {
                return this.isLastStep && this.countSteps <= 2 && this.activeStep === 'complete-form';
            },

            sideDistancePx() {
                return this.display < 465 ? 0 : this.settings.right_distance + 'px';
            },

            bottomDistancePx() {
                return this.settings.bottom_distance + 'px';
            }
        },

        methods: {
            manageTextArea(textAreaId) {
                let textAreaContentSize = 0;
                let textArea = 'textareaMessage';
                let resizeIndex = 'resizeIndexMessage';
                if(textAreaId === 'swell-chat-message'){
                    textAreaContentSize = this.form.message.length;
                }
                if(textAreaId === 'swell-chat-additional_notes') {
                    textAreaContentSize = this.form.additional_notes.length;
                    textArea = 'textareaAdditionalNotes';
                    resizeIndex = 'resizeIndexAdditionalNotes';
                }
                let elem = window.document.querySelector("#" + textAreaId);
                if (elem) {
                    let height = elem.scrollHeight;
                    let row    = 1;
                    if (height <= 34) {
                        row = 1;
                    } else {
                        row = ((height - 34) / 20) + 1;
                        if (row > this[textArea].rows) {
                            this[resizeIndex].push({
                                row: row,
                                size: textAreaContentSize,
                            });
                        } else {
                            if (this[resizeIndex].length && this[resizeIndex][this[resizeIndex].length - 1].size - 1 > textAreaContentSize) {
                                this[resizeIndex].pop();
                                if (!this[resizeIndex].length) {
                                    row = 1;
                                } else {
                                    row = this[resizeIndex][this[resizeIndex].length - 1].row;
                                }
                            }
                        }
                    }
                    if (!textAreaContentSize) {
                        this[textArea].rows = 1;
                        this[resizeIndex] = [];
                        return;
                    }
                    this[textArea].rows = row;
                }
            },

            accessSwellSite() {
                if(!this.settings.use_cobrand) {
                    window.open('https://swellcx.com', '_blank');
                } else {
                    window.open(this.settings.cobrand_url, '_blank');
                }

            },
            onResize() {
                this.display = window.innerWidth;
            },

            setupForm() {
                this.form = new Form({
                    url             : this.settings.click_url ? window.location.href : '',
                    data_api        : this.data_api,
                    flow            : 'webchat',
                    name            : '',
                    phone_number    : '',
                    message         : '',
                    group_id        : '',
                    user_type_selected: null,
                    preferred_times : [],
                    preferred_days  : [],
                    additional_notes: '',
                    country_code    : this.customizations.default_country_code_id,
                });
            },

            closeWelcome() {
                this.welcome   = false;
                let now        = new Date();
                let expiration = now.setMinutes(now.getMinutes() + 120);
                localStorage.setItem(this.localStorageKey, JSON.stringify({
                    expires_at: expiration,
                    value     : this.data_api
                }));
            },

            localStorageWelcome() {
                let delay = this.settings.welcome_delay ? this.settings.welcome_delay : 1.5;
                let data = localStorage.getItem(this.localStorageKey);
                let now  = new Date();
                if (!data) {
                    setTimeout(() => {
                        this.welcome = true;
                    }, delay * 1000);
                    return;
                }

                let storage = JSON.parse(data);

                if (storage.expires_at < now.getTime()) {
                    localStorage.removeItem(this.localStorageKey);
                    this.welcome = true;
                    return;
                }

                // For webchats before deploying expires_at
                if (!storage.expires_at) {
                    localStorage.removeItem(this.localStorageKey);
                    this.welcome = true;
                }
            },

            localStorageClicked() {
                let data    = localStorage.getItem(this.localStorageKeyClick);
                let storage = JSON.parse(data);
                let now     = new Date();

                if (storage && (storage.expires_at < now.getTime())) {
                    localStorage.removeItem(this.localStorageKeyClick);
                    return;
                }
            },

            launcherClick() {
                if(!this.opened){
                    this.triggerGtagEvent('webchat_opened');
                    this.transitioning = true;
                    setTimeout(() => {
                        this.transitioning = false;
                    }, 300);
                } else {
                    this.triggerGtagEvent('webchat_closed');
                }

                this.setupForm();
                this.gotoFirstStep();
                this.clearSelectedGroup();
                this.opened     = !this.opened;
                this.submitting = false;
                this.tcrAccepted = false;

                if (this.welcome) {
                    this.closeWelcome();
                }

                this.saveClick();
            },

            async getCustomizations() {
                await axios.get(`${this.base_url}/api/v1/webchat/settings`, {
                    params: {
                        data_api: this.data_api
                    }
                })
                    .then(({data}) => {
                        this.customizations = data;
                        if (this.customizations.appointment) {
                            this.selectChatType('apptRequest');
                        } else {
                            this.selectChatType('webchatOnly');
                        }

                        this.launcher = true;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                this.localStorageWelcome();
                this.localStorageClicked();
            },

            send() {
                this.submitting = true;
                this.form.flow  = this.settings.is_webchat ? 'webchat' : 'appointment';

                this.form.post(`${this.base_url}/api/v1/webchat/send`)
                    .then(({data}) => {
                        this.phone_number = data['location_number'] ? data['location_number'] : this.settings.team_phone_number;
                        this.nextStep();
                        this.triggerGtagEvent('webchat_submission');
                    })
                    .catch(error => {
                        console.log()
                        this.gotoFormStep();
                        this.submitting = false;
                    });
            },

            saveClick() {
                let data    = localStorage.getItem(this.localStorageKeyClick);
                let storage = JSON.parse(data);

                if (!data && this.data_api) {
                    let now        = new Date();
                    let expiration = now.setMinutes(now.getMinutes() + 120);
                    localStorage.setItem(this.localStorageKeyClick, JSON.stringify({
                        expires_at: expiration,
                        value     : this.data_api
                    }));

                    axios.put(`${this.base_url}/api/v1/webchat/location-selected`, {
                        data_api  : this.data_api,
                        properties: {
                            'origin'       : window.location.origin,
                            'device'       : this.device(),
                            'screen_width' : window.innerWidth,
                            'screen_height': window.innerHeight
                        }
                    });
                }
            },

            device() {
                let testDevice = navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i);

                return testDevice ? 'mobile' : 'desktop';
            },

            groupSearchFilter(searchString) {
                this.filteredSelectedGroups = [];
                if (searchString === null || searchString.match(/^ *$/) !== null) {
                    this.filteredSelectedGroups = this.settings.webchat_groups;
                    this.failedGroupFilter      = false;
                    return;
                }

                if (!this.settings.webchat_groups.length) {
                    return;
                }

                this.settings.webchat_groups.forEach((group) => {
                    searchString = searchString.toLowerCase();

                    if (group.name.toLowerCase().includes(searchString) || group.description.toLowerCase().includes(searchString)) {
                        this.filteredSelectedGroups.push(group);
                    }
                });

                this.failedGroupFilter = !this.filteredSelectedGroups.length;
            },

            clearSelectedGroup() {
                this.selectedGroup = null;
                this.form.group_id = '';
            },

            groupSelected(group) {
                this.selectedGroup = group;
                this.form.group_id = group.id;
                this.sendMessage   = true;
                this.nextStep();
            },

            backToGroups() {
                this.clearSelectedGroup();
                this.sendMessage   = false;
                this.opened        = true;
            },

            mergeAppointmentWithWebchatCustomization() {
                let fields = [
                    'use_cobrand',
                    'cobrand_url',
                    'cobrand_logo',
                    'cobrand_name',
                    'bg_launcher_color',
                    'bg_header_color',
                    'welcome_text',
                    'right_distance',
                    'bottom_distance',
                    'avatar',
                    'avatar_url',
                    'custom_avatar',
                    'bg_header_group_color',
                    'custom_icon',
                    'icon_url',
                    'bg_header_color',
                    'title_header',
                    'text_header',
                    'text_invitation',
                    'corner',
                    'welcome_alignment',
                    'welcome_delay',
                    'click_url',
                ];
                if( this.customizations.webchat ) {
                    for (let i = 0; i < fields.length; i++) {
                        this.customizations.appointment[fields[i]] = this.customizations.webchat[fields[i]];
                    }
                } else {
                    this.customizations.appointment.bg_header_group_color = '#' + this.customizations.appointment.appointment_request_webpage.background_color;
                    this.customizations.appointment.bg_launcher_color = '#' + this.customizations.appointment.appointment_request_webpage.background_color;
                    this.customizations.appointment.bg_header_color = '#' + this.customizations.appointment.appointment_request_webpage.background_color;
                    this.customizations.appointment.right_distance = 30;
                    this.customizations.appointment.bottom_distance = 30;
                    this.customizations.appointment.custom_icon = this.base_url + '/storage/' + this.customizations.appointment.appointment_request_webpage.logo;
                    this.customizations.appointment.icon_url = this.base_url + '/storage/' + this.customizations.appointment.appointment_request_webpage.logo;
                    this.customizations.appointment.title_header = this.customizations.appointment.appointment_request_webpage.header;
                    this.customizations.appointment.text_header = this.customizations.appointment.appointment_request_webpage.description;
                }

                return this.customizations.appointment;
            },

            selectChatType(selected) {
                this.flow.sequences.steps = this.flow.sequences[selected];

                if (selected === 'apptRequest') {
                    this.settings = this.mergeAppointmentWithWebchatCustomization();
                    this.settings.is_webchat = false;
                } else {
                    this.settings            = this.customizations.webchat;
                    this.settings.is_webchat = true;
                }
                if (!(this.customizations.appointment && this.customizations.webchat)) {
                    this.removeStep('type-selector');
                }

                if (this.settings.use_groups) {
                    if (!this.settings.webchat_groups.length) {
                        this.settings.use_groups = false;
                    } else {
                        this.filteredSelectedGroups = this.settings.webchat_groups;
                        this.sendMessage            = false;
                    }
                } else {
                    this.removeStep('group-selector');
                }

              if ('use_user_type' in this.settings && (! this.settings.use_user_type)) {
                    this.removeStep('recurrent-patient-selector');
              }

                if (!this.settings.use_preferred_days) {
                    this.removeStep('preferred-day-selector');
                }

                if (!this.settings.use_preferred_times) {
                    this.removeStep('preferred-time-selector');
                }

                if (!this.settings.use_additional_notes) {
                    this.removeStep('additional-notes-form');
                }

                this.settings.team_phone_number = this.customizations.team_phone_number;
                this.filteredSelectedGroups     = this.settings.webchat_groups;

                this.nextStep();
            },

            removeStep(step) {
                let stepIndex = this.flow.sequences.steps.indexOf(step);
                if (stepIndex >= 0) {
                    this.$delete(this.flow.sequences.steps, stepIndex);
                }
            },

            gotoFirstStep() {
                this.flow.activeStep = 0;
            },

            gotoFormStep() {
                let found = false;
                this.flow.formSteps.forEach((form) => {
                    let index = this.flow.sequences.steps.indexOf(form);
                    if (!found && index >= 0) {
                        found                = true;
                        this.flow.activeStep = index;
                    }
                });
            },

            nextStep() {
                if ((this.flow.activeStep + 1) < this.countSteps) {
                    this.flow.activeStep++;
                }
            },

            previousStep() {
                if (this.flow.activeStep > 0) {
                    this.flow.activeStep--;
                }
            },

            setExistingPatient(exist) {
                this.form.user_type_selected = exist;
                if (!this.isLastStep) {
                    this.nextStep();
                }
            },

            setPreferredDay(day) {
                let index = this.form.preferred_days.indexOf(day);
                if (index >= 0) {
                    this.$delete(this.form.preferred_days, index);
                } else {
                    this.$set(this.form.preferred_days, this.form.preferred_days.length, day);
                }
            },

            setPreferredTime(time) {
                let index = this.form.preferred_times.indexOf(time);
                if (index >= 0) {
                    this.$delete(this.form.preferred_times, index);
                } else {
                    this.$set(this.form.preferred_times, this.form.preferred_times.length, time);
                }
            },

            toggleSelectedButton(checked) {
                return {
                    color          : checked ? '#ffffff' : '#6b7280',
                    backgroundColor: checked ? this.bgHeaderColor : '#f4f5f7',
                };
            },

            triggerGtagEvent(event) {
                if(this.check_swell_analytics_callback_is_loaded()) {

                    window.swellAnalyticsCallback(this.getEventData(event))
                } else if(this.check_gtag_is_loaded()) {
                    let eventData = this.getEventData(event);
                    window.gtag('event', eventData.event, {
                        'event_category': eventData.event_category,
                        'event_label': eventData.event_label,
                    });
                }

                return;
            },

            getEventData(event) {
                switch (event) {
                    case 'webchat_opened':
                        return {
                            'event': 'swell_webchat_event',
                            'event_category': 'webchat_opened',
                            'event_label': 'webchat_opened'
                        }
                    case 'webchat_closed':
                        return {
                            'event': 'swell_webchat_event',
                            'event_category': 'webchat_closed',
                            'event_label': 'webchat_closed'
                        }
                    case 'webchat_submission':
                        return {
                            'event': 'swell_webchat_event',
                            'event_category': 'webchat_submission',
                            'event_label': this.form.flow + ' submission',
                        }

                }
            },

            check_swell_analytics_callback_is_loaded() {
                return typeof window.swellAnalyticsCallback === 'function';
            },

            check_gtag_is_loaded() {
                return typeof window.gtag === 'function';
            },

            async fetchCountryCodes() {
                await axios.get(`${this.base_url}/api/available-country-codes`)
                    .then(({data}) => {
                        this.countryCodes = data;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            messageCount() {
                this.message_count = this.form.message.length;
            },

            additionaNotesCount() {
                this.additional_notes_count = this.form.additional_notes.length;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "./chat";
</style>
